import axios from 'axios'
import env from '../../../env'
import url_parse from 'url-parse'
import helpers from '../../../helpers'
import i18n from 'vue-i18n'
import Locale from '../../../vue-i18n-locales.generated';
import router from './../../routes';

let $t = (item) => localStorage.getItem('language') ? Locale[localStorage.getItem('language')][item] : Locale['ua'][item];

let commonXhrHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('token'),
};
let commonXhrHeadersWithFile = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('token'),
};

export default {
    state: {
        students_payer: [],
        teachers_payer: [],
        curators_payer: [],
        timetables_payer: null,
        current_document: [],
        subscriptions_payer: [],
        payments_payer: [],
        routerQuery: null,
        notification: {
            text: '',
            isActive: false,
        },
        refreshPages: null
    },
    mutations: {
        'SET_REFRESH_PAGES'(state, refreshPages) {
            state.refreshPages = refreshPages;
        },
        'SET_NOTIFICATION_ALERT'(state, notification) {
            state.notification = notification;
        },
        'SET_ROUTER_QUERY'(state, query) {
            state.routerQuery = query
        },
        'SET_PAYER_STUDENTS'(state, payload) {
            state.students_payer = payload
        },
        'SET_PAYER_TEACHERS'(state, payload) {
            state.teachers_payer = payload;
        },
        'SET_PAYER_CURATORS'(state, payload) {
            state.curators_payer = payload;
        },
        'SET_PAYER_TIMETABLES'(state, payload) {
            state.timetables_payer = payload;
        },
        'SET_CURRENT_DOCUMENT'(state, payload) {
            if (payload.results && payload.results.length > 0) {
                let next_page,
                    prev_page;
                if (Number.isInteger(payload.next) !== true && payload.next !== null) {
                    if (url_parse(payload.next, true).query && url_parse(payload.next, true).query.page === undefined) {
                        next_page = null
                    } else {
                        next_page = parseInt(url_parse(payload.next, true).query.page)
                    }
                } else {
                    next_page = payload.next
                }

                if (Number.isInteger(payload.previous) !== true && payload.previous !== null) {
                    if (url_parse(payload.previous, true).query && url_parse(payload.previous, true).query.page === undefined) {
                        prev_page = 1
                    } else {
                        prev_page = parseInt(url_parse(payload.previous, true).query.page)
                    }
                } else {
                    prev_page = payload.previous
                }

                state.current_document = {
                    results: payload.results,
                    next: next_page,
                    previous: prev_page,
                    count: payload.count
                }
            } else if (payload.results && payload.results.length === 0) {
                state.current_document = ['Not found']
            } else {
                if (state.current_document.results && state.current_document.results.length) {
                    state.current_document.results.unshift(payload);
                    state.refreshPages = payload;
                } else {
                    state.current_document = payload;
                    state.refreshPages = payload;
                }
            }
        },
        'SET_SUBSCRIPTIONS_PAYER'(state, payload) {
            state.subscriptions_payer = payload;
        },
        'SET_PAYMENTS_PAYER'(state, payload) {
            let next_page,
                prev_page;
            if (Number.isInteger(payload.next) !== true && payload.next !== null) {
                if (url_parse(payload.next, true).query && url_parse(payload.next, true).query.page === undefined) {
                    next_page = null
                } else {
                    next_page = parseInt(url_parse(payload.next, true).query.page)
                }
            } else {
                next_page = payload.next
            }

            if (Number.isInteger(payload.previous) !== true && payload.previous !== null) {
                if (url_parse(payload.previous, true).query && url_parse(payload.previous, true).query.page === undefined) {
                    prev_page = 1
                } else {
                    prev_page = parseInt(url_parse(payload.previous, true).query.page)
                }
            } else {
                prev_page = payload.previous
            }

            state.payments_payer = {
                results: payload.results,
                next: next_page,
                previous: prev_page,
                count: payload.count
            };
        },
    },
    actions: {
        'GET_PAYER_STUDENTS'({commit}, payload) {
            commit('SET_PAYER_STUDENTS', payload)
        },
        'GET_PAYER_TEACHERS'({commit, state}, id) {
            let data = state.students_payer.find(el => {
                return el.id === id;
            });
            commit('SET_PAYER_TEACHERS', data.teachers)
        },
        'GET_PAYER_CURATORS'({commit, state}, id) {
            let data = state.students_payer.find(el => {
                return el.id === id;
            });
            commit('SET_PAYER_CURATORS', data.curators)
        },
        'GET_TIMETABLES_LIST'({commit, state}, {student_id, date_from, date_to}) {
            return new Promise((resolve, reject) => {
                axios.get(env.api_url + 'timetables/', {
                    headers: commonXhrHeaders,
                    params: {
                        student_id,
                        date_from,
                        date_to,
                    }
                }).then(response => {
                    resolve(response.data.data);
                    commit('SET_PAYER_TIMETABLES', response.data.data)
                }, err => reject(err));
            })
        },
        'SET_DOCUMENTS_PAYER'({commit, state}, {name, doc_file, id, status, lang = localStorage.getItem('language')}) {
            commit('SET_SHOW_PRELOADER', true);

            let formData = new FormData();
            formData.append("name", name);
            
            if (Array.isArray(doc_file)) {
                doc_file.forEach(file => {
                    formData.append("doc_file", file);
                });
            } else {
                formData.append("doc_file", doc_file);
            }

            formData.append("student", id);
            // formData.append("status", status.id);
            formData.append("lang", lang);
            axios.post(env.api_url + 'documents/', formData, {
                headers: commonXhrHeadersWithFile,
            }).then((response) => {
                commit('SET_CURRENT_DOCUMENT', response.data.data)
                commit('SET_NOTIFICATION_ALERT', {text: $t('success_document'), isActive: true});
            }).catch(error => {
                console.log(error);
                let type_files_error = error.response.data.data.non_field_errors ? $t('valid_file_types') : '';
                commit('SET_NOTIFICATION_ALERT', {text: $t('error_file') + '. ' + type_files_error, isActive: true});
            })
            .then(() => {
                commit('SET_SHOW_PRELOADER', false);
            });
        },
        'SET_DOCUMENT_SIGNATURE_PAYER'({commit, dispatch, state}, {id, doc_file}) {
            commit('SET_SHOW_PRELOADER', true);

            let formData = new FormData();
            
            if (Array.isArray(doc_file)) {
                doc_file.forEach(file => {
                    formData.append("doc_signature", file);
                });
            } else {
                formData.append("doc_signature", doc_file);
            }
            
            axios.put(env.api_url + `document/${id}/`, formData, {
                headers: commonXhrHeadersWithFile,
            }).then((response) => {
                
                state.current_document.results.forEach((e) => {
                    if (e.id === response.data.data.id) {
                        e.doc_signature = response.data.data.doc_signature;
                        // e.need_signature = response.data.data.need_signature;
                        e.doc_type = response.data.data.doc_type;
                        e.status_name = response.data.data.status_name;
                        e.is_pending = response.data.data.is_pending;
                        return false
                    }
                });
                commit('SET_NOTIFICATION_ALERT', {text: $t('success_document'), isActive: true});
            }).catch(error => {
                console.log(error);
                let type_files_error = error.response.data.data.non_field_errors ? $t('valid_file_types') : '';
                commit('SET_NOTIFICATION_ALERT', {text: $t('error_file') + '. ' + type_files_error, isActive: true});
            })
            .then(() => {
                commit('SET_SHOW_PRELOADER', false);
            });
        },
        'GET_DOCUMENTS_PAYER'({commit, state}, {id, page = null, lang = localStorage.getItem('language'), page_size = 5, q = ''}) {
            if (page === null) {
                let url = new URL(window.location);
                page = url.searchParams.get('page')
            }
            if (page_size === null) {
                let url = new URL(window.location);
                page_size = url.searchParams.get('rows')
            }
            let data = {
                student_id: id,
                page: page,
                lang: lang,
                page_size: page_size,
            };
            if (q !== '') {
                data.q = q
            }
            return new Promise((resolve, reject) => {
                axios.get(env.api_url + 'documents/', {
                    headers: commonXhrHeaders,
                    params: data
                }).then((response) => {
                    resolve(response)
                    commit('SET_CURRENT_DOCUMENT', response.data.data)
                }, (err) => {
                    reject(err)
                    console.log(err);
                })
            })
        },
        'GET_SUBSCRIBTIONS_PAYER'({commit, state}, {id, page = null, lang = localStorage.getItem('language'), page_size = 999}) {
            // if (page === null) {
            //     let url = new URL(window.location);
            //     page = url.searchParams.get('page')
            // }
            let data = {
                student_id: id,
                lang: lang,
                page_size: page_size,
            };
            return new Promise((resolve, reject) => {
                axios.get(env.api_url + 'subscriptions/', {
                    headers: commonXhrHeaders,
                    params: data
                }).then((response) => {
                    resolve(response)
                    commit('SET_SUBSCRIPTIONS_PAYER', response.data.data)
                }, (err) => {
                    reject(err)
                    console.log(err);
                })
            })
        },
        'GET_PAYMENTS_PAYER'({commit, state}, {id, page = null, lang = localStorage.getItem('language'), page_size = 5, q = ''}) {
            if (page === null) {
                let url = new URL(window.location);
                page = url.searchParams.get('page')
            }
            let data = {
                student_id: id,
                page: page,
                lang: lang,
                page_size: page_size,
            };
            if (q !== '') {
                data.q = q
            }
            return new Promise((resolve, reject) => {
                axios.get(env.api_url + 'payments/', {
                    headers: commonXhrHeaders,
                    params: data
                }).then((response) => {
                    resolve(response)
                    commit('SET_PAYMENTS_PAYER', response.data.data)
                }, (err) => {
                    reject(err)
                    console.log(err);
                })
            })
        }
    },
    getters: {
        notification: state => state.notification,
        students_payer: state => state.students_payer,
        teachers_payer: state => state.teachers_payer,
        curators_payer: state => state.curators_payer,
        timetables_payer: state => state.timetables_payer,
        current_document_payer: state => state.current_document,
        routerQuery: state => state.routerQuery,
        refreshPages: state => state.refreshPages,
        subscriptions_payer: state => state.subscriptions_payer,
        payments_payer: state => state.payments_payer,
        student: state =>  {
            return state.students_payer && state.students_payer.length ? state.students_payer.find(student => {
                    return +router.currentRoute.params.child_id === student.id;
                }) : undefined;
        },
        students_payer_billed: state =>  {
            return state.students_payer.filter(function(student) {
                return student.is_billed;
            });
        }
    }
}